import { FloraTag } from '@grupoboticario/flora-react'

import { isHomologEnvironment } from '@/utils/envUtils'

import * as S from './HomologationTag.styles'

const HomologationTag = () => {
  if (!isHomologEnvironment()) {
    return null
  }

  return (
    <FloraTag css={S.tagCss} size="medium" styleSemantic="alert" type="readOnly">
      Homologação
    </FloraTag>
  )
}

export { HomologationTag }
